import { render } from "./ButtonDeleteSidepanelItems.vue?vue&type=template&id=7dee5a55&scoped=true"
import script from "./ButtonDeleteSidepanelItems.vue?vue&type=script&lang=js"
export * from "./ButtonDeleteSidepanelItems.vue?vue&type=script&lang=js"

import "./ButtonDeleteSidepanelItems.vue?vue&type=style&index=0&id=7dee5a55&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dee5a55"]])

export default __exports__